<template>
  <footer class="temFoot"> 
    东莞市灵猴智能科技有限公司 Copyright © 2019-2020 All Rights Reserved 版权所有
    <a target="_blank" href="http://beian.miit.gov.cn">粤ICP备19001243号</a>
  </footer>
</template>

<script>
export default {
  beforeCreate() {
    var _this = this;
  },
  mounted() {
    var _hmt = _hmt || [];
    (function() {
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?2319036249c25748e694cf42e90c9f1a";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();
  }
};
</script>
<style>
#nb_icon_wrap,
#nb_nodeboard,
#nb_invite_wrap {
  display: none !important;
}
/* #aff-im-root .embed-icon .embed-group-icon .embed-group-icon__item {
  background: burlywood !important;
} */
/*  #nb_nodeboard {
    position: fixed;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%);
  }*/
</style>



// WEBPACK FOOTER //
// src/views/public/foot.vue